import styled from '@emotion/styled'

export const Container = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
`
